import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import { deleteUser, updateUser } from "../graphQL/graphMutation";

export const updateEmployeeService = async (id, values) => {
  let updateStatus = false;
  try {
    const res = await request(BASEURL, updateUser, {
      input: {
        id: id,
        ...values,
      },
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateContactService error");
    updateStatus = false;
  }

  return updateStatus;
};

export const deleteEmployeeService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteUser,{id:id});
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteContactService error");
    delteStatus = false;
  }
  return delteStatus;
};
